export const groupInvoiceLines = (lines, lang = 'en') => {
    if (!lines || !Array.isArray(lines)) return lines;

    const grouped = [];
    const hotelLinesMap = new Map();

    lines.forEach(line => {
        // We only aggregate hotel rooms. Other types (flights, tours, transfers, hotel_extras) remain as is.
        if (line.line_type === 'hotel_room') {
            // Safe fallback for room ID if missing
            const roomId = line.metadata?.room_category_id || 'no_room';
            // Determine the price to group by
            const price = line.effective_unit_price ?? line.unit_price;
            // Determine the base description to group by (using English as standard key if available)
            const descEn = line.description?.en || line.description?.ar || '';
            
            // Generate a unique key for this hotel + room + price combination
            const key = `hotel_room_${line.product_id}_${roomId}_${price}_${descEn}`;

            if (hotelLinesMap.has(key)) {
                const existingGroup = hotelLinesMap.get(key);
                existingGroup.quantity += line.quantity;
                existingGroup.line_total += line.line_total;
                existingGroup.display_line_total += line.display_line_total;
                existingGroup.effective_line_total += line.effective_line_total;
                existingGroup._nights = (existingGroup._nights || 1) + 1;
            } else {
                // Deep clone to avoid mutating the original Redux/state object
                const newGroup = JSON.parse(JSON.stringify(line));
                newGroup._nights = 1;
                hotelLinesMap.set(key, newGroup);
                grouped.push(newGroup);
            }
        } else {
            // Push non-hotel lines as they are
            grouped.push(line);
        }
    });

    // Update the description of grouped hotel rooms to include the total number of nights and room category
    grouped.forEach(item => {
        if (item.line_type === 'hotel_room' && item._nights > 0) {
            const isAr = lang === 'ar';
            
            // Calculate rooms per night
            const roomsCount = item.quantity / item._nights;
            
            let roomsTextAr = `${roomsCount} غرف`;
            if (roomsCount === 1) roomsTextAr = 'غرفة';
            else if (roomsCount === 2) roomsTextAr = 'غرفتين';
            
            const roomsTextEn = roomsCount === 1 ? '1 Room' : `${roomsCount} Rooms`;
            
            const nightsTextAr = item._nights === 1 ? 'ليلة واحدة' : item._nights === 2 ? 'ليلتين' : `${item._nights} ليالي`;
            const nightsTextEn = item._nights === 1 ? '1 Night' : `${item._nights} Nights`;

            // Set display quantity matching "5 ليالي × غرفتين"
            item.display_quantity = isAr 
                ? `${nightsTextAr} × ${roomsTextAr}` 
                : `${nightsTextEn} × ${roomsTextEn}`;
            
            const hotelNameAr = item.description?.ar || '';
            const hotelNameEn = item.description?.en || '';
            
            const roomNameObj = item.metadata?.room_category_name;
            const roomNameAr = roomNameObj ? (roomNameObj.ar || roomNameObj.en) : '';
            const roomNameEn = roomNameObj ? (roomNameObj.en || roomNameObj.ar) : '';

            // Construct new description: "Hotel Name - Room Category"
            item.description = {
                ar: `${hotelNameAr}${roomNameAr ? ` - ${roomNameAr}` : ''}`,
                en: `${hotelNameEn}${roomNameEn ? ` - ${roomNameEn}` : ''}`
            };
        }
    });

    return grouped;
};
